/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import RawPlatMap from '@bd/bdui-platmap';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import HomeMapCard from '../../components/HomeMapCard';
import LotCard from '../../components/LotCard';
import { colors, typography } from '../../styles';

const PlatMap = withData(
  {
    community: true,
    lots: true,
    homes: true,
  },
  {
    community: true,
  },
)(RawPlatMap);

const modalStyles = css`
  position: absolute;
  top: 30px;
  width: 80vw;
  left: 50%;
  margin-left: -40vw;
  height: auto;
  background-image: url('/images/comm-detail-description-bg-fpo.jpg');
  background-size: cover;
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(63,63,63,.85);
  }
  @media (max-width: 991px) {
    top: 15px;
    left: 15px;
    right: 15px;
    width: auto;
    margin: 0;
  }
  .SitePlanModal_header {
    background-color: ${colors.color2Dark};
    background-size: 25% auto;
    background-repeat: repeat-y;
    background-position: left top;
    z-index: 2;
    position: relative;
    padding: 50px 30px 30px 30px;
    @media (max-width: 991px) {
      padding: 10px 30px 10px 10px;
    }
    img {
      width: 100%;
      height: auto;
      float: left;
      margin: 0 30px 0 0;
      @media (max-width: 991px) {
        display: none;
      }
    }
  }
  .SitePlanModal_title {
    font-family: ${typography.SansSerif};
    font-size: 36px;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 40px;
    margin: 0;
    @media (max-width: 991px) {
      font-size: 24px;
      line-height: 24px;
    }
  }
  .SitePlanModal_postTitle{
    display: block;
    font-size: 24px;
    color: ${colors.color3};
    @media (max-width: 991px) {
      font-size: 18px;
    }
  }
  .SitePlanModal_body {
    padding: 30px;
    position: relative;
    z-index: 2;
    @media (max-width: 991px) {
      padding: 15px 0;
    }
    .btn {
      background-color: ${colors.color1};
      background-image: none;
      padding: 10px 15px;
    }
  }
  .invalid-feedback {
    color: #FFFFFF;
  }

  a.modal-close {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 10;
    font-size: 30px;
    line-height: 30px;
    color: #FFFFFF;
  }

  .SitePlanModal_platMap .leaflet-container {
    height: 75vh;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.3);
  overflow-y: auto;
`;

class SitePlanModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: true });
  }

  closeModal(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, community, buttonClassName, homes } = this.props;
    return (
      <div>
        <span role="button" tabIndex={0} className={buttonClassName} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <a href="" onClick={this.closeModal} className="modal-close">&times;</a>
          <div className="SitePlanModal_header">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h3 className="SitePlanModal_title">{_.get(community, 'name')} Site Plan</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="SitePlanModal_body">
            <div className="container">
              <div className="row">
                <div className="col-12 SitePlanModal_platMap">
                  <PlatMap
                    shapes
                    boundarySize={1}
                    community={community}
                    homes={homes}
                    popup={({ marker = {} }) => (
                      <div className="home-popup">
                        {
                          marker.type === 'home' &&
                          <HomeMapCard home={marker} />
                        }
                        {
                          marker.type === 'lot' &&
                          <LotCard lot={marker} />
                        }
                      </div>
                    )}
                    tooltip={marker => (
                      <div>
                        {
                          !marker.isLot &&
                          <span>
                            Available Home
                            <br />
                            {marker.address.streetAddress}
                          </span>
                        }

                        {
                          marker.isLot &&
                          <span>
                            Available Lot
                            <br />
                            {marker.address.streetAddress}
                          </span>
                        }
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

SitePlanModal.propTypes = {
  community: PropTypes.object,
  children: PropTypes.node,
  buttonClassName: PropTypes.string,
  homes: PropTypes.arrayOf(PropTypes.object),
};

SitePlanModal.defaultProps = {
  community: undefined,
  children: undefined,
  buttonClassName: undefined,
  homes: [],
};

export default SitePlanModal;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SitePlanModal.js